import { Component, OnInit } from '@angular/core';
import { Store, select } from '@ngrx/store';
import ls from 'localstorage-slim';
import { Observable } from 'rxjs';
import { map, skipWhile } from 'rxjs/operators';
import { ModalContent } from 'src/app/models/modal-content.model';
import {
  HomeViewModel,
  selectHomeViewModel
} from 'src/app/store/selectors/home/home.selectors';
import { environment } from 'src/environments/environment';
import { CLIENT } from '../../../app.constants';
import { ProfileImage } from '../../../models/profile-image.model';
import { scaleIn400ms } from '../../../shared/utils/animations/scale-in.animation';
import { profileInitials } from '../../../shared/utils/initials.utils';
import { AppState } from '../../../store';
import * as fromDashboardActions from '../../../store/actions/dashboard/dashboard.actions';
import * as fromCrmSelectors from '../../../store/selectors/crm/crm.selectors';
import { selectProfileImage } from '../../../store/selectors/profile/profile.selectors';
import { PermissionService } from '../../auth/services/permission.service';
import { mainNavigation } from '../main-navigation';

ls.config.encrypt = true;

@Component({
  selector: 'lns-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
  animations: [scaleIn400ms]
})
export class LayoutComponent implements OnInit {
  navigationItems = mainNavigation;
  client: string | null = '';
  profileInitials = profileInitials();
  exchangeModalOpened = false;
  locationModalOpened = false;
  environment = environment;
  savings: any = [];
  deposits: any = [];
  loans: any = [];
  cards: any = [];
  profileImage$: Observable<ProfileImage>;
  crmData$: Observable<fromCrmSelectors.CrmModel>;

  exchangeContent: ModalContent = {
    title: 'more_option_external_link_title',
    content: 'more_option_external_link_text',
    buttons: []
  };

  locationContent: ModalContent = {
    title: 'more_options_locations',
    content: 'more_option_external_link_location_text',
    buttons: []
  };

  constructor(
    private store: Store<AppState>,
    private permissionService: PermissionService
  ) {
    this.profileImage$ = this.store.select(selectProfileImage);
    this.crmData$ = this.store.pipe(select(fromCrmSelectors.selectCRMOffers));
  }

  ngOnInit(): void {
    this.store.dispatch(fromDashboardActions.loadDashboardApi());
    this.store.dispatch(fromDashboardActions.loadProfileImageApi());
    this.getClient();
    this.loadAccounts();
  }

  getClient(): void {
    this.client = ls.get(CLIENT);
  }

  openExchangeModal(): void {
    this.exchangeModalOpened = !this.exchangeModalOpened;
  }

  openLocationModal(): void {
    this.locationModalOpened = !this.locationModalOpened;
  }

  hasAppPermission(permission: any) {
    return this.permissionService.hasAppPermission(permission);
  }

  crmBgColor() {
    return document.location.href.includes('/crm');
  }

  loadAccounts() {
    this.store.dispatch(fromDashboardActions.refreshDashboardApi());
    this.store
      .pipe(
        select(selectHomeViewModel),
        skipWhile(value => value.accounts === null),
        map((homeViewModel: HomeViewModel) => {
          return {
            accounts: homeViewModel.accounts,
            savings: homeViewModel.savings,
            deposits: homeViewModel.deposits,
            loans: homeViewModel.loans,
            cards: homeViewModel.cards
          };
        })
      )
      .subscribe(allAccounts => {
        this.loans = allAccounts.loans;
        this.savings = allAccounts.savings;
        (this.deposits = allAccounts.deposits),
          (this.cards = allAccounts.cards);
      });
  }

  /* Check cards on layout*/
  checkIfLinkVisible(nav: any) {
    if (
      (nav.name === 'more_options_savings' && !this.savings?.length) ||
      (nav.name === 'more_options_deposits' && !this.deposits?.length) ||
      (nav.name === 'more_options_credit' && !this.loans?.length) ||
      (nav.name === 'menu_cards' && !this.cards?.length)
    ) {
      return false;
    } else return true;
  }
}
